import { memo, useContext } from 'react';
import { string } from 'prop-types';
import { getEnv } from '../environment';
import GlobalNavInternalContext from './context/GlobalNavInternalContext';
import OptimizelyProvider from './context/OptimizelyProvider';
import { UniversalNavigationContext } from './context/UniversalNavigationContext';
import GlobalNavContent from './GlobalNavContent';
import { useBootstrapLD } from './hooks/useBootstrapLD';

const GlobalNav = ({ env: envName = '', ...props }) => {
  const env = getEnv(envName);
  const externalContextData = useContext(UniversalNavigationContext);
  const {
    downloadMobileAppWebBannerFF,
    downloadMobileAppWebBannerReady,
    mobileAppWebBannerUniversalLinksFF,
    mobileAppWebBannerUniversalLinksReady,
    mobileAppWebBannerLoyaltyProgramFF,
    mobileAppWebBannerLoyaltyProgramReady,
    ordersCtaFF,
    ordersCtaReady,
    webRatingsAndReviewInGlobalNavDropDownFF,
    webRatingsAndReviewInGlobalNavDropDownReady,
    ccToastNotificationFF,
    ccToastNotificationReady,
  } = useBootstrapLD(env.name);

  const contextValue = {
    env,
    mainProps: { ...props },
    ...externalContextData,
    flags: {
      downloadMobileAppWebBannerFF,
      downloadMobileAppWebBannerReady,
      mobileAppWebBannerUniversalLinksFF,
      mobileAppWebBannerUniversalLinksReady,
      mobileAppWebBannerLoyaltyProgramFF,
      mobileAppWebBannerLoyaltyProgramReady,
      ordersCtaFF,
      ordersCtaReady,
      webRatingsAndReviewInGlobalNavDropDownFF,
      webRatingsAndReviewInGlobalNavDropDownReady,
      ccToastNotificationFF,
      ccToastNotificationReady,
    },
  };

  return (
    <OptimizelyProvider>
      <GlobalNavInternalContext.Provider value={contextValue}>
        <GlobalNavContent />
      </GlobalNavInternalContext.Provider>
    </OptimizelyProvider>
  );
};

GlobalNav.propTypes = {
  env: string,
};

export default memo(GlobalNav);
